// extracted by mini-css-extract-plugin
export default {"fill":"CheckCircleIcon_fill__HcjB9"};